import React, { useState, Fragment } from 'react'
import { Radar } from '@nivo/radar'
import cn from 'classnames'

import Button from 'app/components/ButtonDefault'
// @ts-ignore
import { trimString } from 'helpers/common'
// @ts-ignore
import { COLORS, DIRECT, PEERS, SELF, SUPERVISORS, COLORS_FOR_RADAR_CHART_T2 } from '../../Reports'
import TitleForRadarAndBar from '../TitleForRadarAndBar'
import { IRadarChartT2Props } from './interface'
import './styles.scss'

const bc = 'radar-chart-t2'

const theme = {
  axis: {
    ticks: {
      text: {
        fontSize: 12,
      },
    },
  },
  dots: {
    text: {
      fontSize: 14,
    },
  },
}

const LabelComponent = ({ id, anchor }: any): any => {
  const offsetX = id.length
  const isMiddle = anchor === 'middle'
  const isEnd = anchor === 'end'
  return (
    <g transform={`translate(${isEnd ? -offsetX * 6 : isMiddle ? -offsetX * 4 : 0}, 0)`}>
      <text
        style={{
          fontSize: '14px',
          fontFamily: 'Avenir, sans-serif',
          fontWeight: 500,
          fontStretch: 'normal',
          fontStyle: 'normal',
          lineHeight: 1.54,
          letterSpacing: 'normal',
          fill: '#626262',
        }}
      >
        {isMiddle ? id.toUpperCase() : trimString(id.toUpperCase(), 9)}
      </text>
    </g>
  )
}

const RadarChartT2: React.FC<IRadarChartT2Props> = ({ data, reviewers }) => {
  const [key, setKey] = useState(SELF)
  return (
    <Fragment>
      <TitleForRadarAndBar
        // @ts-ignore
        reviewerType={key}
        title="Competency Ratings"
      />
      <Radar
        // @ts-ignore
        data={data[key]}
        keys={['t1', 't2']}
        indexBy="competency"
        width={500}
        height={450}
        colors={(node: any) => {
          return COLORS_FOR_RADAR_CHART_T2[node.key][key]
        }}
        maxValue={4}
        fillOpacity={0}
        margin={{ top: 70, right: 0, bottom: 80, left: 0 }}
        blendMode="normal"
        gridLevels={4}
        gridShape="circular"
        curve="linearClosed"
        borderWidth={3}
        borderColor={{ from: 'color' }}
        gridLabelOffset={10}
        animate
        motionStiffness={90}
        motionDamping={15}
        // @ts-ignore
        theme={theme}
        dotSize={0}
        gridLabel={LabelComponent}
      />
      <div className={`${bc}__buttons`}>
        <Button
          onClick={() => {
            setKey(SELF)
          }}
          className={cn(`${bc}__button`, `${bc}__self`, { [`${bc}__unselected`]: key !== SELF })}
        >
          Self
        </Button>
        <Button
          onClick={() => {
            setKey(PEERS)
          }}
          className={cn(`${bc}__button`, `${bc}__peer`, { [`${bc}__unselected`]: key !== PEERS })}
        >
          Peer
        </Button>
        <Button
          onClick={() => {
            setKey(SUPERVISORS)
          }}
          className={cn(`${bc}__button`, `${bc}__superior`, {
            [`${bc}__unselected`]: key !== SUPERVISORS,
          })}
        >
          Supervisors
        </Button>
        <Button
          onClick={() => {
            setKey(DIRECT)
          }}
          className={cn(`${bc}__button`, `${bc}__employee`, { [`${bc}__unselected`]: key !== DIRECT })}
        >
          D.Reports
        </Button>
      </div>
    </Fragment>
  )
}

export default RadarChartT2
